module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "divider"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5486b40d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/dropdown-divider.vue
// module id = 696
// module chunks = 85